module.exports = __webpack_public_path__ + "img/MTN-logo.6ca8deac.jpg";